import { useAuth } from '../auth/AuthProvider'
import { SupplierCatalogPage } from '../components/SupplierCatalogPage'

export const SupplierCatalogScreen = () => {
  const { session } = useAuth()
  if (!session) {
    return null
  }

  return (
    <SupplierCatalogPage organizationId={session.organizationId} importPath="/catalog/import" />
  )
}
